<script setup lang="ts"></script>

<template>
  <section class="screen">
    <div class="spinner-large" aria-hidden="true"></div>
    <h2 class="title">Adding your course…</h2>
    <p class="lede">
      Hang tight — we're attaching the voucher and queueing up your dashboard.
    </p>
  </section>
</template>

<style scoped>
.screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.5rem 0 0.5rem;
}

.title {
  font-family: 'Fraunces', Georgia, serif;
  font-size: 1.6rem;
  letter-spacing: -0.02em;
  color: var(--coco-900);
  margin: 1.25rem 0 0.4rem;
  font-weight: 500;
}
.lede {
  margin: 0;
  color: var(--ink-soft);
  max-width: 28em;
}

.spinner-large {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 4px solid var(--lime-100);
  border-top-color: var(--lime-600);
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
